export enum DatetimeType {
  None        = 0,
  Submission  = 1,
  Custom      = 2,
  Formula     = 3,
}